import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { MentionCustomizationModel } from './mention-customization.model';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';

export class MentionCustomizationFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    includeNotes?: boolean;
    allowExpertMode?: boolean = true;
    changeDefaultStyleStateOptions: (x: any) => DropdownOptionModel[];

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        includeNotes?: boolean,
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[]
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        if (includeNotes !== undefined) {
            this.includeNotes = includeNotes;
        }
        this.changeDefaultStyleStateOptions = changeDefaultStyleStateOptions;
    }
}
